import SettingsScreen from "@/components/settings/SettingsPage";

export default function SettingsPage() {
  return <SettingsScreen />;
}
